module.exports = __webpack_public_path__ + "img/main-bg-first-block.ebce2465.png";